//6. Sub-menu links inaccessible for keyboard-only and screen reader users
jQuery(document).ready(function(){
  $(".sf__sub-menu-link1").attr("aria-expanded", "false");
  $(".sf__sub-menu-link2").attr("aria-expanded", "false");
  $('.sf-menu-submenu__items2 .ecs a').removeAttr('aria-expanded');
 
   jQuery("body").on("keydown",".sf__menu-item-level1:not(.sf__sub-menu-link1--active)", function(e){
        if(e.keyCode == 13) {  
           jQuery(".flex-prev").css("opacity", "1");
            jQuery(this).addClass("sf__sub-menu-link1--active");
            jQuery(".sf__sub-menu-link1--active").find('a').attr("aria-expanded",'true');
            e.preventDefault();
        }
    }); 

   $(".sf__sub-menu-link2").attr("aria-expanded", "false");
   jQuery("body").on("keydown",".sf__menu-item-level2:not(.sf__sub-menu-link2--active)", function(e){
        if(e.keyCode == 13) {  
            jQuery(this).addClass("sf__sub-menu-link2--active");
            jQuery(".sf__sub-menu-link2--active").find('a').attr("aria-expanded",'true');
            e.preventDefault();
        }
    }); 

   jQuery("body").on("keyup",".sf__menu-item-level1", function(e){
      if(e.keyCode == 9) {
        jQuery(this).focus();  
        jQuery(".flex-prev").css("opacity", "1");
        jQuery(".flex-next").css("opacity", "1");
        jQuery(".slick-prev").css("opacity", "1");
        jQuery(".slick-next").css("opacity", "1");
        jQuery(".submit-cart").css("display", "block");
        jQuery(".submit-cart").css("opacity", "1");
        // jQuery(".thumbnail-link").addClass("thumbnail-link--active");  
        jQuery(".sf__menu-item-level1").not(this).removeClass("sf__sub-menu-link1--active");  
        jQuery(".sf__menu-item-level1").not(this).find('a').attr('aria-expanded',"false");
        jQuery(".sf-menu__submenu").closest('.sf__sub-menu-link1--active').next('a').attr('aria-expanded',"true"); 
        e.preventDefault();
      }
    });

  jQuery("body").on("keyup",".sf__menu-item-level2", function(e){
      if(e.keyCode == 9) {
        jQuery(this).focus(); 
        jQuery(".flex-prev").css("opacity", "1");
        jQuery(".flex-next").css("opacity", "1");
        jQuery(".slick-prev").css("opacity", "1");
        jQuery(".slick-next").css("opacity", "1");
        jQuery(".submit-cart").css("opacity", "1");
        jQuery(".sf__menu-item-level2").not(this).removeClass("sf__sub-menu-link2--active");  
        jQuery(".sf__menu-item-level2").not(this).find('a').attr('aria-expanded',"false");
        jQuery(".sf-menu__submenu2").closest('.sf__sub-menu-link2--active').next('a').attr('aria-expanded',"true"); 
        e.preventDefault();
      }
    });

   jQuery("#menu a").on("keydown", function(e) {
      if(e.keyCode == 27) {
          $(this).closest('.sf__menu-item-level1').find('a.sf__sub-menu-link1').focus();
       
          if (jQuery(this).parent().parent().prev().prev().length) {
              jQuery(this).parent().parent().prev().prev().parent().removeClass("sf__sub-menu-link1--active");
              jQuery(this).find('a').parent().parent().prev().prev().parent().attr("aria-expanded","false");
              jQuery(".sf-menu__submenu").find(".sf-menu-submenu__items a").removeAttr("aria-expanded");
          } else { 
              jQuery('li').find('a').attr('aria-expanded',"false");
              jQuery('li').removeClass("sf__sub-menu-link1--active");   
              jQuery(".sf-menu__submenu").find(".sf-menu-submenu__items a").removeAttr("aria-expanded");
          }
          return
      }
   });

   jQuery("#menu a").on("keydown", function(e) {
      if(e.keyCode == 27) {
          $(this).closest('.sf__menu-item-level2').find('a.sf__sub-menu-link2').focus();
          if (jQuery(this).parent().prev().length) {
             // alert("hi");
              jQuery(this).parent().removeClass("sf__sub-menu-link2--active");
              jQuery(this).find('a').parent().attr("aria-expanded","false");
              jQuery(".sf-menu__submenu2").find(".sf-menu-submenu__items2 a").removeAttr("aria-expanded");
          } else { 
             // alert("hi123");
              jQuery('.sf__menu-item-level2').find('a').attr('aria-expanded',"false");
              jQuery('.sf__menu-item-level2').removeClass("sf__sub-menu-link2--active");   
              jQuery(".sf-menu__submenu2").find(".sf-menu-submenu__items2 a").removeAttr("aria-expanded");
          }
          return
      }
   });

    jQuery(".sixteen.columns:eq(2)").focusin(function(){
        jQuery(".sf__menu-item-level1").not(this).removeClass("sf__sub-menu-link1--active");  
        jQuery(".sf__menu-item-level1").not(this).find('a').attr('aria-expanded',"false");
    })
                  
})
// 6. Sub-menu links inaccessible for keyboard-only and screen reader users


jQuery("body").on("keydown",".four:not(.four--active)", function(e){
        if(e.keyCode == 9) {
          jQuery(this).addClass("four--active");
          jQuery(".action_button").addClass("success");
          jQuery(".four--active .quick_shop_play.action_button.play-button").attr("tabindex", "0").focus();
          jQuery('.four').not(this).find(".action_button").removeClass("success");
          jQuery('.four').not(this).removeClass("four--active");
          e.preventDefault();
        }
    });
// 

jQuery(document).ready(function(){
  var adaCommand = '<!-- Updated! -->';
  
  // //
  jQuery('.container.content').attr('role', 'main').before(adaCommand);
  jQuery('.footer').attr('role', 'contentinfo').before(adaCommand);
  // //

// 
jQuery('.collection h1').attr('class' , 'sr-only');
// 

  jQuery('.article-image').attr({
    'tabindex' : '-1',
    'aria-hidden' : 'true'
  }).before(adaCommand);  
  // //
  jQuery('.contact-form .contact_email').attr('autocomplete', 'email').before(adaCommand);
  // //
  jQuery('hr').attr('role', 'presentation').before(adaCommand);

  // 
  setTimeout(function(){
      jQuery('div.draggable:eq(0) .thumbnail-link img').attr('alt' , '');
      jQuery('div.draggable:eq(1) .thumbnail-link img').attr('alt' , '');
  }, 1000);
  // 
  setTimeout(function(){
      jQuery(".flex-next").attr("aria-label","Carousel");
      jQuery(".flex-next").attr("role","region");
  }, 1000);

    setTimeout(function(){
      jQuery(".flex-prev").attr("aria-label","Carousel");
      jQuery(".flex-prev").attr("role","region");
  }, 1000);

//
  setTimeout(()=>{
    var i = 1;
    jQuery(".section.clearfix .article").each(function () {
      jQuery(this).find("h3").attr("id", "sr-only"+i);
      jQuery(this).find(".acont a").attr("id", "read"+i);
      jQuery(this).find(".acont a").attr('aria-labelledby', 'sr-only'+ i +' read'+ i);
      i+=1;
    })
  }, 500)

//
  setTimeout(()=>{
    var i = 1;
    jQuery(".section.clearfix .article").each(function () {
      jQuery(this).find("h3").attr("id", "sr-only"+i);
      jQuery(this).find(".add_to_cart").attr("id", "add"+i);
      jQuery(this).find(".add_to_cart").attr('aria-labelledby', 'add'+ i + 'sr-only'+ i);
      i+=1;
    })
  }, 500)

  //
    jQuery('.sixteen .columns .thumbnail-link img').attr('alt' , '');
    
    jQuery('.sixteen .columns .thumbnail-link').attr({
        'tabindex' : '-1',
        'aria-hidden' : 'true'
      }).before(adaCommand);
    //
  jQuery('#homepage_slider .flex-pauseplay a').attr('href', '#');


  // var playPauseText = jQuery('#homepage_slider .flex-pauseplay a').text();
  // jQuery('#homepage_slider .flex-pauseplay a').html('<span class="sr-only">'+playPauseText+'</span>');
  
  // jQuery('#homepage_slider .flex-pauseplay a').click(function(){
  //     var playPauseText = jQuery(this).text();
  //   	jQuery(this).html('<span class="sr-only">'+playPauseText+'</span>');	
  // })
  
  // jQuery('#homepage_slider .flex-pauseplay a').keyup(function(e){
  // 	if(e.keyCode == 13){	
  //     alert("ji");
  //     var playPauseText = jQuery(this).text();
  //   	jQuery(this).html('<span class="sr-only">'+playPauseText+'</span>');
  // 	}
  // })

// jQuery('#homepage_slider .flex-pauseplay a').keyup(function(e) {
//     if (e.keyCode == 13) {        
//         if ($(this).hasClass('flex-pause')) {
            
//             $(this)
//                 .removeClass('flex-pause')
//                 .addClass('flex-play')
//                 .text('') // Update text to 'play'
//                 .attr('aria-label', 'play');
//         } else if ($(this).hasClass('flex-play')) {
            
//             $(this)
//                 .removeClass('flex-play')
//                 .addClass('flex-pause')
//                 .text('') // Update text to 'pause'
//                 .attr('aria-label', 'pause');
//         }
//     }
// });
  
})













